import { useMutation, useQueryClient } from 'react-query';
import { useDoctorPortalApiContext } from 'contexts/ApiContext';
import { DoctorQueryKey } from 'config/doctorQueryKey';
import { DoctorMutationKey } from 'config/doctorMutationKey';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';
import { assignVisit } from '@higo/api';

export const useAssignVisitMutation = (visitId: number) => {
  const queryClient = useQueryClient();
  const intl = useIntl();
  const { authorizedAxios } = useDoctorPortalApiContext();

  return useMutation(
    [DoctorMutationKey.AssignVisits, visitId],
    assignVisit(authorizedAxios),
    {
      onSuccess: async (_, variables) => {
        toast.success(
          intl.formatMessage({
            id: 'examinationsAssignment.assignedSuccessfully',
          }),
        );

        await queryClient.invalidateQueries(
          DoctorQueryKey.UnassignedVisitsList,
        );
        await queryClient.invalidateQueries(DoctorQueryKey.Visits);
        await queryClient.invalidateQueries(DoctorQueryKey.AssignedVisitsList);
      },

      onError: (_, variables) => {
        toast.error(
          intl.formatMessage({
            id: 'examinationsAssignment.notAssignedSuccessfully',
          }),
        );
      },
    },
  );
};
